import React from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';

function AboutUs() {
    return (
        <>
            <div className="wrapper">
                <Header />
                
                {/* Page Title Section */}
                <section className="page-title-layout1 page-title-light bg-overlay bg-parallax text-center bg-img" style={{ backgroundImage: `url("assets/images/page-titles/1.jpg")`, backgroundSize: "cover", backgroundPosition: "center center" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 offset-xl-3">
                                <h1 className="pagetitle__heading">About Us</h1>
                                <nav>
                                    <ol className="breadcrumb justify-content-center mb-0">
                                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">About Us</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Main Content Section */}
                <section className="py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                
                                <div className="mb-5">
                                    <h4>Welcome to RocketPaisa</h4>
                                    <p className="text-muted"><strong>A Brand of CJL Fintech Solutions</strong></p>
                                    <p>RocketPaisa is a leading digital fintech brand operated by CJL Fintech Solutions, committed to delivering innovative, secure, and accessible financial services across India. Our platform is designed to empower retailers, CSPs, entrepreneurs, and businesses by providing a wide range of digital financial solutions through a single, easy-to-use platform.</p>
                                    <p>At RocketPaisa, we believe that technology can transform the way financial services are delivered. Our goal is to bridge the gap between financial institutions and end customers by enabling fast, secure, and reliable digital transactions, especially in underserved and rural areas.</p>
                                </div>

                                <div className="mb-5">
                                    <h4>Who We Are</h4>
                                    <p>CJL Fintech Solutions is a technology-driven fintech company focused on building digital infrastructure that enables financial inclusion and business growth. Through the RocketPaisa platform, we provide merchants and partners with access to multiple financial and utility services, helping them serve their customers efficiently while creating sustainable income opportunities.</p>
                                </div>

                                <div className="mb-5">
                                    <h4>Our Services</h4>
                                    <p>RocketPaisa offers a comprehensive suite of digital financial services, including:</p>
                                    <ul className="row list-unstyled check-list">
                                        <li className="col-md-6 mb-2">✓ Cash Withdrawal & Cash Deposit Services</li>
                                        <li className="col-md-6 mb-2">✓ Micro ATM Services</li>
                                        <li className="col-md-6 mb-2">✓ Aadhaar Pay</li>
                                        <li className="col-md-6 mb-2">✓ Mobile & DTH Recharge</li>
                                        <li className="col-md-6 mb-2">✓ Bharat Connect (BBPS) Bill Payments</li>
                                        <li className="col-md-6 mb-2">✓ PAN Card Services</li>
                                        <li className="col-md-6 mb-2">✓ Insurance Services</li>
                                        <li className="col-md-6 mb-2">✓ Travel & Utility Services</li>
                                        <li className="col-md-6 mb-2">✓ Digital Payment Solutions</li>
                                    </ul>
                                </div>

                                {/* Mission and Vision Side-by-Side Grid */}
                                <div className="row mb-5">
                                    <div className="col-md-6 mb-4 mb-md-0">
                                        <h4>Our Mission</h4>
                                        <p>To make digital financial services accessible, affordable, and reliable for every Indian by leveraging technology, innovation, and a strong partner network.</p>
                                    </div>
                                  
                                </div>

                                <div className="row mb-5">
                                    <div className="col-md-6 mb-4 mb-md-0">
                                        <h4>Our Vision</h4>
                                        <p>To become one of India's most trusted fintech ecosystems by empowering retailers, businesses, and communities with secure and innovative digital financial solutions.</p>
                                    </div>
                                  
                                </div>



                                <div className="mb-5">
                                    <h4>Why Choose RocketPaisa?</h4>
                                    <ul>
                                        <li>Secure and Technology-Driven Platform</li>
                                        <li>Fast and Reliable Transactions</li>
                                        <li>Multiple Services Through a Single Portal</li>
                                        <li>Dedicated Partner Support</li>
                                        <li>Transparent Business Practices</li>
                                        <li>Scalable Solutions for Retailers and Enterprises</li>
                                        <li>Commitment to Financial Inclusion</li>
                                    </ul>
                                </div>

                                <div className="mb-5">
                                    <h4>Our Commitment</h4>
                                    <p>At RocketPaisa, we are committed to maintaining the highest standards of security, compliance, transparency, and customer satisfaction. We continuously work towards enhancing our platform and expanding our services to create greater value for our partners and customers.</p>
                                    <p className="lead font-weight-bold mt-3">RocketPaisa is more than a fintech platform—it's a mission to empower businesses, enable financial inclusion, and drive India's digital transformation.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        </>
    );
}

export default AboutUs;